export default __webpack_public_path__ + "static/media/bg-wellness.d3333d27.jpg";